<template>
  <div class="grid h-screen grid-cols-10">
    <div
      class="col-span-4 md:!block !hidden h-svh bg-image relative flex-center"
    >
      <img
        alt="auth logo svg"
        src="/images/auth/auth-bg.png"
        class="size-full object-cover object-right-top"
      />
      <img
        alt="auth logo svg"
        src="/images/auth/bg.png"
        class="size-full absolute inset-0"
      />
      <Transition name="fade" mode="out-in">
        <div
          v-if="!loading"
          class="absolute bottom-8 right-8 flex gap-x-2 items-center"
        >
          <a :href="contactData?.instagram?.link" target="_blank">
            <i class="icon-instagram text-[28px] text-white" />
          </a>
          <a :href="contactData?.youtube?.link" target="_blank">
            <i class="icon-youtube text-[28px] text-white" />
          </a>
          <a :href="contactData?.telegram?.link" target="_blank">
            <i class="icon-telegram text-[28px] text-white" />
          </a>
          <a :href="contactData?.facebook?.link" target="_blank"
            ><i class="icon-facebook text-[28px] text-white"
          /></a>
        </div>
        <div
          v-else
          class="absolute bottom-[35px] rounded-lg h-[30px] w-[140px] right-8 flex gap-x-2 items-center shimmer"
        ></div>
      </Transition>
    </div>
    <div
      class="relative flex-center-between md:col-span-6 col-span-10 flex-col overflow-y-scroll max-h-screen bg-gray-100 gap-4 overflow-y-auto"
    >
      <div class="h-[calc(100%-100px)] flex-center w-full shrink-0">
        <Transition name="fade" mode="out-in">
          <slot />
        </Transition>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, computed } from "vue";
import { useCustomToast } from "@/composables/useCustomToast";
import { useContactStore } from "@/modules/Profile/contactsStore";

const { showErrorToast } = useCustomToast();
const contactStore = useContactStore();

const contactData = computed(() => contactStore.contactData);
const loading = computed(() => contactStore.loading);

onMounted(async () => {
  try {
    await contactStore.fetchContactInfo();
  } catch (error) {
    showErrorToast("Failed to load contact information");
  }
});
</script>

<style scoped>
.bg-image {
  /* background-image: url("/images/Authorization/banner.avif"); */
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
</style>
